module.exports = __webpack_public_path__ + "static/media/lds-qur.941010e2.jpg";